import Vue from "vue";
import Router from "vue-router";
import Home from "@/components/Home";
import About from "@/components/About";
import Term from "@/components/Term";
import PublicityDetail from "@/components/PublicityDetail";

Vue.use(Router);
console.log(123123);
export default new Router({
  routes: [
    {
      path: "/",
      name: "Home",
      component: Home,
    },
    {
      path: "/home",
      name: "Home",
      component: Home,
    },
    {
      path: "/about",
      name: "About",
      component: About,
    },
    {
      path: "/term",
      name: "Term",
      component: Term,
    },
    {
      path: "/publicity/detail",
      name: "PublicityDetail",
      component: PublicityDetail,
    }
  ],
});
